var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34565 11.1282L9.8628 7.69126H6.62269V5.45723C6.62269 4.51744 7.07652 3.59912 8.5277 3.59912H10V0.672328C10 0.672328 8.65963 0.441406 7.38259 0.441406C4.7124 0.441406 2.9657 2.09008 2.9657 5.07057V7.69126H0V11.1282H2.9657V19.4414H6.61741V11.1282H9.34037H9.34565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebook-white.c18d95057d29b52ba23754a9d94b29ca.svg";
export { ForwardRef as ReactComponent };